var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26302 13.5872C5.97135 13.5872 5.72483 13.4865 5.52344 13.2852C5.32205 13.0838 5.22135 12.8372 5.22135 12.5456V2.33724H1.47135C1.17969 2.33724 0.93316 2.23654 0.731771 2.03516C0.530382 1.83377 0.429688 1.58724 0.429688 1.29557C0.429688 1.00391 0.530382 0.757379 0.731771 0.55599C0.93316 0.354601 1.17969 0.253906 1.47135 0.253906H11.0547C11.3464 0.253906 11.5929 0.354601 11.7943 0.55599C11.9957 0.757379 12.0964 1.00391 12.0964 1.29557C12.0964 1.58724 11.9957 1.83377 11.7943 2.03516C11.5929 2.23654 11.3464 2.33724 11.0547 2.33724H7.30469V12.5456C7.30469 12.8372 7.20399 13.0838 7.0026 13.2852C6.80122 13.4865 6.55469 13.5872 6.26302 13.5872Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTIcon);
export default __webpack_public_path__ + "static/media/t_icon.ea6a968d.svg";
export { ForwardRef as ReactComponent };